import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=919dafe6&"
import script from "./CustomDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports